import styled, { keyframes } from 'styled-components'
import { rem } from 'polished'

const rotateGradient = keyframes`
  from {
    transform: translate(var(--ai-glow-inline-translate), -50%) rotate(0deg);
  }
  to {
    transform: translate(var(--ai-glow-inline-translate), -50%) rotate(360deg);
  }
`

/**
 * A wrapper component that applies a rotating AI glow border effect.
 * Wrap any element with this component to give it an animated gradient border.
 *
 * The child element will automatically get:
 * - position: relative and z-index: 1 to appear above the gradient
 * - white background and border-radius to match the glow
 */
const AIGlowBorder = styled.div`
  --ai-glow-inline-translate: -50%;

  position: relative;
  width: 100%;
  border-radius: ${rem(4)};
  padding: ${rem(2)};
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    inset-inline-start: 50%;
    width: max(100vw, 100%);
    aspect-ratio: 1;
    background: conic-gradient(
      from 0deg,
      ${props => props.theme.palette.product.ai.light} 0deg,
      ${props => props.theme.palette.product.ai.dark} 180deg,
      ${props => props.theme.palette.product.ai.light} 360deg
    );
    animation: ${rotateGradient} 2500ms linear infinite;
    z-index: 0;
  }

  [dir='rtl'] & {
    --ai-glow-inline-translate: 50%;
  }

  > * {
    position: relative;
    z-index: 1;
    background: ${props => props.theme.palette.neutral.surface.normalBackground};
    border-radius: ${rem(2)};
  }
`

export default AIGlowBorder
